function Step4Svg() {
    return (
        <svg width='129' height='102' viewBox='0 0 129 102' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <ellipse cx='80.5968' cy='62' rx='39.403' ry='40' fill='#FFEDF3' />
            <circle cx='80.5967' cy='61.4028' r='30.4478' fill='#FFD1E1' />
            <path
                d='M80.8731 47.6997C73.029 47.6997 66.637 54.2476 66.637 62.283C66.637 70.3185 73.029 76.8664 80.8731 76.8664C88.7172 76.8664 95.1092 70.3185 95.1092 62.283C95.1092 54.2476 88.7172 47.6997 80.8731 47.6997ZM87.0658 67.4893C86.8665 67.8393 86.5106 68.0289 86.1404 68.0289C85.9554 68.0289 85.7703 67.9851 85.5995 67.8685L81.1863 65.1705C80.0901 64.4997 79.2786 63.0268 79.2786 61.7289V55.7497C79.2786 55.1518 79.7627 54.656 80.3463 54.656C80.93 54.656 81.414 55.1518 81.414 55.7497V61.7289C81.414 62.2539 81.8411 63.0268 82.2825 63.2893L86.6956 65.9872C87.2081 66.2935 87.379 66.9643 87.0658 67.4893Z'
                fill='#ED236B'
            />
            <circle cx='6' cy='6' r='6' transform='matrix(-1 0 0 1 12 15)' fill='#C6C3FB' />
            <circle cx='4' cy='4' r='4' transform='matrix(-1 0 0 1 64 0)' fill='#FED883' />
            <circle cx='2' cy='2' r='2' transform='matrix(-1 0 0 1 20 75)' fill='#651FFF' />
            <circle cx='3' cy='3' r='3' transform='matrix(-1 0 0 1 129 85)' fill='#FEB5BD' />
        </svg>
    );
}

export default Step4Svg;
